import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '@app/environment';

export const TICKET_WIDGET_TAG = 'pirexpo-ticket-widget';

const LOADER_MARK_ATTR = 'data-bestchefs-ticket-loader';
const WIDGET_LOADER_SRC = environment.production
  ? 'https://prd.widget.pir.ru/widget-loader.prd.min.js'
  : 'https://master.widget.pir.ru/widget-loader.dev.min.js';

@Injectable({ providedIn: 'root' })
export class TicketWidgetLoaderService {
  readonly #document = inject(DOCUMENT);
  readonly #platformId = inject(PLATFORM_ID);

  constructor() {
    if (
      !environment.ticketsEnabled ||
      !isPlatformBrowser(this.#platformId) ||
      this.#document.querySelector(`script[${LOADER_MARK_ATTR}]`)
    ) {
      return;
    }

    const script = this.#document.createElement('script');
    script.src = WIDGET_LOADER_SRC;
    script.async = true;
    script.setAttribute(LOADER_MARK_ATTR, '');
    this.#document.head.appendChild(script);

    const widget = this.#document.createElement(TICKET_WIDGET_TAG);
    this.#document.body.appendChild(widget);
  }
}
